import moment from 'moment';

moment.defaultFormat = 'lll';

export default moment;



// WEBPACK FOOTER //
// ./src/util/moment.js